import { DateRangeFilter, DateRangeFilterProps, DateRangeFilterReturn } from "./date-range";
import { Filter, FilterData } from "./filter";
import { ModelFilter, ModelFilterProps, ModelFilterReturn } from "./model";
import { PaginationFilter, PaginationFilterProps, PaginationFilterReturn } from "./pagination";
import { SelectFilter, SelectFilterProps, SelectFilterReturn } from "./select";
import { StringFilter, StringFilterProps, StringFilterReturn } from "./string";

export type FilterProps = StringFilterProps | DateRangeFilterProps | SelectFilterProps | PaginationFilterProps | ModelFilterProps;
export type FilterReturn = StringFilterReturn | DateRangeFilterReturn | SelectFilterReturn | PaginationFilterReturn | ModelFilterReturn;

export class FilterHandler {
    filters: Filter[]

    constructor(filterProps: FilterProps[]) {
        this.filters = filterProps.map(filterProp => {
            switch (filterProp.type) {
                case "string": return new StringFilter(filterProp);
                case "select": return new SelectFilter(filterProp);
                case "dateRange": return new DateRangeFilter(filterProp);
                case "pagination": return new PaginationFilter(filterProp);
                case "model": return new ModelFilter(filterProp);
            }
        })
    }

    public getInitialValues(): FilterData {
        return this.filters.reduce((prev, filter) => {
            filter.getInitialValues(prev);
            return prev;
        }, {} as FilterData)
    }

    public getFilters(filterData: FilterData): FilterReturn[] {
        return this.filters.map(filter => filter.getFilter(filterData));
    }

    public parse(filterData: FilterData): FilterData {
        return this.filters.reduce((prev, filter) => {
            filter.parse(filterData, prev)
            return prev;
        }, {} as FilterData)
    }

    public async getCriteria(filterData: FilterData): Promise<string[]> {
        const criterias = await Promise.all(this.filters.map(f => f.getCriteria(filterData)));
        return criterias.filter(Boolean);
    }
}